import { apolloClient } from '~/apollo-client';
import { FETCH_DASHBOARD_URL } from '~/components/dashboard-button/dashboard-button.component';
import { LDClient, LDFlags } from '~/providers';
import {
  Flex_FetchDashboardUrlQuery,
  Flex_FetchDashboardWithPathUrlQueryVariables,
  Flex_FetchEmailUpdateStatusQueryVariables,
  Flex_FetchEmailUpdateStatusQuery,
  Flex_FetchDashboardUrlQueryVariables,
} from '~/typings/graphql';
import { IS_CYPRESS, INTERNAL_ROUTES } from '~/utils/constants';
import { hardRedirect } from '~/utils/for-warbler';
import { getRedirectUrl, updateQueryParams } from '~/utils/redirects';
import { store } from '~/utils/store';
import { FETCH_DASHBOARD_WITH_PATH_URL } from './fetch-dashboard-url.queries';
import { FETCH_EMAIL_UPDATE_STATUS } from './fetch-email-update-status.queries';

export interface RedirectToDashboardParams {
  userId: number;
  path?: string;
  utilityAccountId?: number;
  billingExperienceType?: string;
}

export type RedirectToDashboardResponse = void;

export const redirectToDashboard = async (
  params: RedirectToDashboardParams,
): Promise<RedirectToDashboardResponse> => {
  try {
    const { data: status } = await apolloClient.query<
      Flex_FetchEmailUpdateStatusQuery,
      Flex_FetchEmailUpdateStatusQueryVariables
    >({
      query: FETCH_EMAIL_UPDATE_STATUS,
      variables: { utilityAccountId: params.utilityAccountId! },
    });

    const { data } = await apolloClient.query<
      Flex_FetchDashboardUrlQuery,
      Flex_FetchDashboardWithPathUrlQueryVariables
    >({
      query: FETCH_DASHBOARD_WITH_PATH_URL,
      variables: { userId: params.userId, path: params.path! },
    });

    if (IS_CYPRESS || store.get('NO_DASHBOARD')) return;
    const redirectUrl = getRedirectUrl(
      data.user.url,
      status?.utilityAccount?.updateAccountSettingsScrapeUuid,
      params.billingExperienceType,
    );

    let url = LDClient.variation(LDFlags.shouldResyncUtilityCredential)
      ? redirectUrl
      : data.user.url;

    if (
      LDClient.variation(LDFlags.showRewardsGuidelines) &&
      params.billingExperienceType === 'acb'
    ) {
      url = updateQueryParams(url, { showRewardsGuidelines: true });
    }

    store.clearAll();
    window.location.assign(url);
  } catch (e) {
    store.clearAll();
    hardRedirect(INTERNAL_ROUTES.EXPIRED_SESSION);
  }
};

export const redirectToDashboardFromDocusignTimeout = async (params: RedirectToDashboardParams) => {
  const { data } = await apolloClient.query<
    Flex_FetchDashboardUrlQuery,
    Flex_FetchDashboardUrlQueryVariables
  >({
    query: FETCH_DASHBOARD_URL,
    fetchPolicy: 'no-cache',
    variables: { userId: params.userId },
  });

  if (data?.user?.url) {
    let redirectionUrl = data.user.url;

    if (LDClient.variation(LDFlags.showRewardsGuidelines)) {
      redirectionUrl = updateQueryParams(redirectionUrl, { showRewardsGuidelines: true });
    }
    window.location.assign(redirectionUrl);
  }
};
